import React,{Component} from 'react'
import Helmet from "react-helmet";
import DeliveryPublicStep from '../../components/step/delivery-public-step'
import {Select,Input,Button,Row,Col,Steps,message,Modal,Tabs,AutoComplete,Timeline} from 'antd'
import {
    baseUrl,
    getPublicTrails,
    getPublicOrderDetail, getPublicOrderList, getOrderTrails
} from '../../api'
import './track-query.less'
import {splitStr,pathStrSplit} from '../../utills/subStringUtill'
import logoImg from '../../assets/images/mobile-logo.png'
import {ReactBingmaps} from 'react-bingmaps'
import ajax from "../../api/ajax";
import RouteStepViewForm from "../route/route-step-view";
import axios from 'axios'
const { Option } = Select;
const { Step } = Steps;
const { TabPane } = Tabs;
const typeItem = {
    'order':'订单号',
    'delivery':'物流单号',
    'boxNo':'集装箱号',
    'GPS':'GPS设备号'
}
class TrackQuery extends Component {
    state = {
        bingmapKey: "AuXjIRtmvSChnWxFOVerDnOU8EZyQ-LXI-w9zsxkmEYFR9DmScWoZFM88YcTw6uv",
        center: [],
        visible:false,
        dataSource: [],
        rowId: 1,
        recordNo:'',
        type:'order',
        order: {

        },
        orderNo:"",
        gpsNo:"",
        boxNo:'',
        carNo:'',
        factoryNo:'',
        recordNoData:[],
        currentStep: 0,
        destinationCity: '',
        mapData: [],
        exportShow:false,
        stepDescription:[],
        searchValue:"",
        selectMap:{},
        orderId:'',
        allData:[],
        placeholder:'请输入13位订单号',
        orderNodes:[],
        vehicleData: [],
    }
    scrollInto=(id)=>{
        let anchorElement = document.getElementById(id);
        if(anchorElement) {
            this.setState({
                activeId:id,
            })
            anchorElement.scrollIntoView({block: "start", inline: "start"});
        }else{
            //console.log(id+" not found")
        }
    }

    getOrderShortFunc = async (id) => {
        let result = await getPublicOrderDetail(id)
        if (result.code === 200) {
            var data = result.data;
            data.start = data.originCountry +' '+ data.originCity;
            data.destination = data.destinationCountry +' '+ data.destinationCity;
            this.setState({
                order: data,
                orderId:data.orderId,
                destinationCity: '到达' + data.destinationCity,
                commitDt: data.commitDt,
                deliveryDt:data.deliveryDt,
            })
            if(data.routeType==='N'){
                this.getOrderNodes(id);
            }
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {
            message.error(result.message)
        }
    }

    timer_two = (record) => setTimeout(
        () => {
            this.getPublicTrails(record)
        },
        2000
    );

    getPublicDelivery = (orderNo) =>{
        axios.get(baseUrl + '/d/public/delivery', { // 配置对象
            params: {orderNo:orderNo} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                // debugger
                if (result.data && result.data.length > 0) {
                    const data = [];
                    let boxNo = '';
                    let factoryNo = '';
                    for (let i = 0; i < result.data.length; i++) {
                        result.data[i].id = i+1;
                        result.data[i].key = i;
                        data.push(result.data[i]);
                        if (i===1 && i < result.data.length - 1) {
                            break;
                        }
                    }
                    let i=0,j=0;
                    for (let o of result.data) {
                        if (o.boxNo) {
                            ++i;
                            boxNo = boxNo + o.boxNo + '，';
                        }
                        if (i===2 && i < result.data.length - 1) {
                            boxNo = boxNo+'...';
                            break;
                        }
                    }
                    for (let o of result.data) {
                        if (o.factoryNo) {
                            ++j;
                            factoryNo = factoryNo + o.factoryNo + '，';
                        }
                        if (j===2 && i < result.data.length - 1) {
                            factoryNo = factoryNo+'...';
                            break;
                        }
                    }
                    boxNo =splitStr(boxNo)
                    factoryNo =splitStr(factoryNo)
                    // debugger
                    this.setState({
                        boxNo: boxNo,
                        factoryNo: factoryNo,
                        mapData:result.data
                    })
                    // this.getPublicTrails(data[0].trailNo)
                    if(this.state.gpsNo==undefined){
                        this.setState({
                            gpsNo:data[0].trailNo
                        })
                    }
                    this.timer_two(this.state.gpsNo)
                    this.getRightOrderTrails(this.state.gpsNo)
                }else{
                    this.setState({
                        boxNo: "",
                        factoryNo: "",
                        mapData:[]
                    })
                }
            } else {
                message.error(result.message)
                return false;
            }
        });
    }

    exportModel = () => {
        let orderNo = this.state.order.orderNo
        window.location.href=baseUrl + "/d/public/opt/export?orderNo="+orderNo;
    }

    getCheckExport = (orderNo) =>{
        axios.get(baseUrl + '/d/public/checkExport', { // 配置对象
            params: {orderNo:orderNo} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                this.setState({
                    exportShow:true
                })
            }else if(result.code === 403){
                this.setState({
                    exportShow:false
                })
            } else {
                this.setState({
                    exportShow:false
                })
                message.error(result.message)
                return false;
            }
        });
    }

    getPublicVehicle = (orderNo) =>{
        axios.get(baseUrl + '/d/public/orderVehicle', { // 配置对象
            params: {orderNo:orderNo} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                // debugger
                if (result.data && result.data.length > 0) {
                    /*let carNo = '';
                    for (let i = 0; i < result.data.length; i++) {
                        if (result.data[i].truckNo) { //车牌号
                            if (result.data[i].truckNo === '********') {
                                carNo = result.data[i].truckNo;
                            } else {
                                carNo = carNo + result.data[i].truckNo + '，';
                            }
                        }
                        if (i===1 && i < result.data.length - 1) {
                            if (carNo != '********') {
                                carNo = carNo+'...';
                            }
                            break;
                        }
                    }
                    carNo =splitStr(carNo)
                    this.setState({
                        carNo: carNo,
                    })*/
                    this.setState({
                        vehicleData: result.data,
                    })
                } else {
                    this.setState({
                        vehicleData: [],
                    })
                }
            } else {
                message.error(result.message)
                return false;
            }
        });
    }

    getOrderNoList = async (type,recordNo) => {
        let result = await getPublicOrderList(type,recordNo)
        if (result.code === 200) {
            if(result.data&&result.data.length>0){
                const orderNo = result.data[0].orderNo
                const gpsNo = result.data[0].trailNo
                this.jumpTo(orderNo,gpsNo,recordNo)
            }else{
                if(type==='order'){
                    message.error('订单号有误')
                }else if(type==='GPS'){
                    message.error('GPS设备号有误')
                }else{
                    message.error('集装箱号有误')
                }
            }

        }else {
            message.error(result.message)
        }

    }
    jumpTo = (orderNo,gpsNo,recordNo)=>{
        let path = '/trackQuery/'+orderNo
        if(gpsNo && gpsNo!=""){
            path = path+"/"+gpsNo
        }

        this.setState(Object.assign(this.state,{
            searchValue:recordNo,
            recordNo:recordNo,
            selectMap:{[this.state.type]:recordNo},
            gpsNo:"",
            boxNo:'',
            carNo:'',
            factoryNo:'',
            recordNoData:[],
            currentStep: 0,
            destinationCity: '',
            mapData: [],
            stepDescription:[],
            allData:[],
        }));
        this.props.history.push(path)
        this.init(orderNo,gpsNo)
    }

    orderNoClick = () =>{
        const {searchValue,type} = this.state
        if(type && type === 'order' && ( !searchValue || searchValue.length<13 )){
            message.error(this.state.placeholder)
            return
        }else if(type && type === 'boxNo' && ( !searchValue || searchValue.length<11 )){
            message.error(this.state.placeholder)
            return
        }else if(type && type === 'GPS' && ( !searchValue || searchValue.length<13 )){
            message.error(this.state.placeholder)
            return
        }
        if(!searchValue){
            message.error('请填写'+typeItem[type])
        }else{
            this.getOrderNoList(type,searchValue)
        }
    }

    componentWillMount() {
        let orderNo = this.props.match.params.orderNo
        let gpsNo = this.props.match.params.gpsNo
        this.init(orderNo,gpsNo)
        this.setState({
            searchValue:orderNo
        })
    }
    init(orderNo,gpsNo){
        if (orderNo) {
            this.setState({
                currentStep:null,
                commitDt:null,
                arriveDt:null,
                declareDt:null,
                passDt:null,
                transportDt:null,
                destinationCity:null,
                destinationDt:null,
            })
            this.getOrderShortFunc(orderNo)
            this.getPublicDelivery(orderNo)
            this.getPublicVehicle(orderNo)
            this.getCheckExport(orderNo)
        }
        this.setState({
            orderNo:orderNo,
            gpsNo:gpsNo,
            recordNo:orderNo,
            selectMap:{[this.state.type]:orderNo}
        });
    }


    getPublicTrails = async (trailNo) => {
        if (trailNo) {
            let result = await getPublicTrails({trailNo,type:'normal',orderNo:this.state.orderNo})
            if (result.code === 200 && result.data.length > 0) {
                let ret = []
                let ret2 = []
                result.data.forEach( (item)=> {
                    let address =
                        '位置:'+ item.address  + '<br/>' +
                        '设备号:'+ item.trailNo + '<br/>' +
                        '到达时间:'+ item.activeDt  + '<br/>' +
                        '纬度:'+ item.latitude + '<br/>' +
                        '经度:'+ item.longitude + '<br/>' +
                        '温度(摄氏):'+ item.uTemperature + '<br/>' +
                        '电量(%):'+ item.uBattery + '<br/>' +
                        '信号强度:'+ item.uSignalstrength;
                    ret.push({
                        "location": [item.latitude, item.longitude],
                        "addHandler": "click",
                        "infoboxOption": {title: "", description: address, maxHeight: 300, maxWidth: 420},
                        "pushPinOption": {title: "", description: "", color: 'DodgerBlue'}, "infoboxAddHandler": {"type" : "click", callback: ()=>{this.scrollInto("step"+item.id)} },
                        "pushPinAddHandler": {"type" : "click", callback: ()=>{this.scrollInto("step"+item.id)} }
                    })
                    ret2.push([item.latitude, item.longitude])
                });
                this.setState({
                    center: ret2[0],
                    infoboxesWithPushPins: ret,
                    polyline: {"location": ret2, "option": {strokeColor: 'DodgerBlue', strokeThickness: 2}},
                });
            } else if (result.code === 200){
                this.setState({
                    center: [],
                    infoboxesWithPushPins: [],
                    polyline:{"location": [], "option": {strokeColor: '', strokeThickness: 0}},
                });
            } else {
                message.error(result.message)
            }
        }
    }


    getRightOrderTrails= async (trailNo) => {
        if (trailNo) {
            let result = await getPublicTrails({trailNo,type:'all',orderNo:this.state.orderNo})
            if (result.code === 200 && result.data.length > 0) {
                let description = []
                result.data.forEach(function (item) {
                    let sesObj = {
                        id:item.id,
                        sts:item.sts,
                        activeDt:item.activeDt,
                        address:item.address,
                        latitude:item.latitude,
                        longitude:item.longitude,
                        uTemperature:item.uTemperature,
                        uSignalstrength:item.uSignalstrength

                    }
                    description.push(sesObj)
                });
                this.setState({
                    stepDescription:description
                });
            } else if (result.code === 200){
                this.setState({
                    stepDescription:[]
                });
            } else {
                message.error(result.message)
            }
        }
    }

    // 选中行
    onClickRow = (record) => {
        return {
            onClick: () => {
                this.getPublicTrails(record.trailNo)
                this.setState({
                    rowId: record.id,
                });
            },
        };
    }

    setRowClassName = (record) => {
        return record.id === this.state.rowId ? 'clickRowStyl' : '';
    }


    //搜索type
    handleTypeChange = (value) => {
        if(value==='order'){
            this.setState({
                placeholder:'请输入13位订单号'
            })
        }else if(value==='boxNo'){
            this.setState({
                placeholder:'请输入11位集装箱号'
            })
        }else if(value==='GPS'){
            this.setState({
                placeholder:'请输入13位GPS'
            })
        }
        this.setState({
            searchValue:this.state.selectMap[value]
        });
        this.setState({
            type:value
        })
    };

    hideModal = () =>{
        this.setState({
            visible:false
        })
    }

    handleSelectChange = (value) => {
        this.setState({
            recordNo:value
        })
    };

    onOrderOk = () =>{
        const {recordNo} = this.state
        this.getOrderShortFunc(recordNo)
        this.getPublicDelivery(recordNo)
        this.getPublicVehicle(recordNo)
        this.setState({
            recordNo:'',
            visible:false
        })
    }

    tabChange = (key) =>{
        this.setState({
            gpsNo:key
        })
        this.getPublicTrails(key)
        this.getRightOrderTrails(key)
        let orderNo = this.state.orderNo
        let gpsNo = key
        let path = '/trackQuery/'+orderNo
        if(gpsNo && gpsNo!=""){
            path = path+"/"+gpsNo
        }
        this.props.history.push(path)
    }
    steDescription = (obj) => {
        if(obj){
            return <div>
                <div>{obj.activeDt}</div>
                <div>{obj.address}</div>
                <div>经度:{obj.latitude}</div>
                <div>纬度:{obj.longitude}</div>
                <div>温度(摄氏):{obj.uTemperature}</div>
                <div>信号强度:{obj.uSignalstrength}</div>
            </div>
        }

    }
    onChange = value => {
        this.setState({
            searchValue:value,
            recordNo:value
        });
        this.getOrderAutoList(this.state.type,value)
        //console.log(value)
    }
    onSelect = value => {
        let type = this.state.type
        let orderNo = ''
        let gpsNo = ''
        if(type=="order"){
            type = "orderNo"
        }else if (type=="boxNo"){
            type = "boxNo"
        }else if (type == "GPS"){
            type = "trailNo"
        }
        for(let i of this.state.allData){
            if(i[type] == value){
                orderNo = i["orderNo"]
                gpsNo = i["trailNo"]
                break;
            }
        }
        this.jumpTo(orderNo,gpsNo,value)
        // let path = '/trackQuery/'+orderNo
        // if(gpsNo && gpsNo!=""){
        //     path = path+"/"+gpsNo
        // }
        // console.log(path)
        // this.props.history.push(path)
        // this.init(orderNo,gpsNo)
        // this.setState({
        //     searchValue:value,
        //     recordNo:value
        // })
        // this.setState({
        //     selectMap:{[this.state.type]:value}
        // });
    }
    getOrderAutoList = async (type,recordNo) => {
        if(type && type === 'order' && ( !recordNo || recordNo.length<13 )){
            this.setState({
                dataSource:[]
            })
            return
        }else if(type && type === 'boxNo' && ( !recordNo || recordNo.length<11 )){
            this.setState({
                dataSource:[]
            })
            return
        }else if(type && type === 'GPS' && ( !recordNo || recordNo.length<13 )){
            this.setState({
                dataSource:[]
            })
            return
        }else if(!recordNo || recordNo.length<2){
            this.setState({
                dataSource:[]
            })
            return
        }
        let result = await getPublicOrderList(type,recordNo)
        if (result.code === 200) {
            if(result.data){
                this.setState({
                    allData:result.data
                })
                let newType = type
                if(type=="order"){
                    newType = "orderNo"
                }else if (type=="boxNo"){
                    newType = "boxNo"
                }else if (type == "GPS"){
                    newType = "trailNo"
                }
                let dataSource = []
                for(let i of result.data){
                    if(i[newType] !=undefined) {
                        dataSource.push(i[newType])
                    }
                }
                // this.setState({
                //     dataSource:[]
                // })
                const data = new Set(dataSource);
                this.setState({
                    dataSource:Array.from(data)
                })
            }
        }else {
            this.setState({
                dataSource:[]
            })
        }
    }
    setColletDt = (date) =>{
        if(date){
            this.setState({
                deliveryDt:date
            })
        }

    }
    getOrderNodes = async (orderNo) => {
        this.setState({
            loading: true,
        })
        let result = await ajax(baseUrl + "/d/public/yg/orderNodes", {orderNo});
        if (result && result.data) {
            let nodes = [];
            if (nodes) {
                nodes = result.data.nodeVos.sort((a, b) => {
                    return a.indx - b.indx
                })
            }
            this.setState({
                orderNodes: nodes,
                routeIOType: result.data.type,
            })
        } else {
            message.error("轨迹信息不存在！")
        }
        this.setState({
            loading: false
        })
    }
    render () {
        const {recordNo,orderNo,gpsNo,dataSource,searchValue,type,recordNoData,visible,stepDescription,mapData,exportShow, vehicleData} = this.state
        return (
            <div className='track-query'>
                <Helmet
                    meta={[
                        {name: "viewport", content: "width=device-width,initial-scale=1.0,user-scalable=no"},
                    ]}
                />
                <div className="track-query-header">
                    <div className="track-query-header-content content1190">
                        <img src={logoImg} alt="logoImg"/>
                        <span className='header-line'></span>
                        <span className='header-title'>跨境货运物流轨迹查询</span>
                        <a href='http://47.105.147.107'>
                           官网首页
                        </a>
                    </div>
                </div>
                <div className="track-query-content content1190">
                    <div className="track-query-content-search">
                        <Select defaultValue={type}  onChange={this.handleTypeChange}>
                            <Option value="order">订单号</Option>
                            {/*<Option value="delivery">物流单号</Option>*/}
                            <Option value="boxNo">
                                集装箱号
                            </Option>
                            <Option value="GPS">GPS设备号</Option>
                        </Select>
                        {/*<Input  value={recordNo} onChange={e => {*/}
                        {/*    this.setState({recordNo: e.target.value})*/}
                        {/*}}/>*/}
                        <AutoComplete
                            dataSource={dataSource}
                            style={{ width:"80%",flex:1}}
                            onFocus={this.onFocus}
                            onChange ={this.onChange}
                            onSelect={this.onSelect}
                            value={searchValue}
                            allowClear={true}
                            backfill={true}
                            placeholder={this.state.placeholder}
                            defaultActiveFirstOption={true}
                        />
                        <Button   onClick={this.orderNoClick}>查询</Button>
                    </div>
                    <div className="track-info-details delivery-box">
                        <div className="delivery-title">
                            订单详情
                        </div>
                        <Row className='track-info-item'>
                            <Col span={6} xs={24} md={6}>
                                <span className='label'>订单编号 : </span>
                                <span>{this.state.order.orderNo}</span>
                            </Col>
                            <Col span={6} xs={24} md={6}>
                                <span className='label'>企业名称: </span>
                                <span>{this.state.order.entName}</span>
                            </Col>
                            <Col span={6} xs={24} md={6}>
                                <span className='label'>起运地 : </span>
                                <span>{this.state.order.start}</span>
                            </Col>
                            <Col span={6} xs={24} md={6}>
                                <span className='label'>转关地: </span>
                                <span>{this.state.order.destinationStartCountry} {this.state.order.destinationStartCity}</span>
                            </Col>
                        </Row>
                        <Row className='track-info-item'>
                            <Col span={6} xs={24} md={6}>
                                <span className='label'>目的地 : </span>
                                <span>{this.state.order.destination}</span>
                            </Col>
                            <Col span={6} xs={24} md={6}>
                                <span className='label'>还箱地: </span>
                                <span>{this.state.order.boxReturnStation}</span>
                            </Col>
                            <Col span={6} xs={24} md={6}>
                                <span className='label'>收货人 : </span>
                                <span>{this.state.order.consignee}</span>
                            </Col>
                            <Col span={6} xs={24} md={6}>
                                <span className='label'>提货时间 : </span>
                                <span>{this.state.deliveryDt}</span>
                            </Col>
                        </Row>
                        <Row className='track-info-item'>
                            <Col span={6} xs={24} md={6}>
                                <span className='label'>集装箱号 ：</span>
                                <span>{this.state.boxNo}</span>
                            </Col>
                            <Col span={6} xs={24} md={6}>
                                <span className='label'>厂封号 ：</span>
                                <span>{this.state.factoryNo}</span>
                            </Col>
                        </Row>
                    </div>
                    <div className="track-info-details delivery-box">
                        <div className="delivery-title">
                            车辆信息
                        </div>
                        {vehicleData.map(t => {
                            return <Row className='track-info-item'>
                                <Col span={6} xs={24} md={6}>
                                    <span className='label'>车牌号 : </span>
                                    <span>{t.truckNo}</span>
                                </Col>
                                <Col span={6} xs={24} md={6}>
                                    <span className='label'>司机姓名 ：</span>
                                    <span>{t.name}</span>
                                </Col>
                                <Col span={6} xs={24} md={6}>
                                    <span className='label'>手机号码 ：</span>
                                    <span>{t.phone}</span>
                                </Col>
                                <Col span={6} xs={24} md={6}>
                                    <span className='label'>身份证号码 ：</span>
                                    <span>{t.identification}</span>
                                </Col>
                            </Row>
                        })}

                    </div>
                </div>

                <div className='delivery-details delivery-box content1190'>
                    <div className="delivery-title">
                        物流状态
                        {exportShow ? <Button type="primary" style={{float:"right",top:'10px'}} onClick={this.exportModel}>导出</Button>:null}
                    </div>
                    <div className='tract-step-info'>
                        {this.state.order.routeType==='N'?
                            <RouteStepViewForm nodes={this.state.orderNodes} routeType={this.state.routeIOType} readOnly={true} loading={this.state.loading} reload={this.getOrderNodes}/>
                            : <DeliveryPublicStep orderNo={this.state.order.orderNo} {...this.props}  setColletDt={this.setColletDt}/>}
                    </div>
                </div>
                <div className='delivery-details delivery-box content1190'>
                    <div className="delivery-title">
                        物流轨迹
                    </div>
                    {
                        mapData? <Tabs  activeKey={this.state.gpsNo} type="card" style={{marginTop:'10px'}} onChange={this.tabChange}>
                            {mapData.map(t => {
                                return t.trailNo?<TabPane tab={t.trailNo} key={t.trailNo}></TabPane>:''
                            })}
                        </Tabs>:null
                    }
                    <div className='delivery-map-box '>
                        <div className="track-step-map" id="bingmap">
                            <ReactBingmaps
                                //center = {[13.0827, 80.2707]}
                                zoom={6}
                                center={this.state.center}
                                bingmapKey={this.state.bingmapKey}
                                polyline={this.state.polyline}
                                infoboxesWithPushPins={this.state.infoboxesWithPushPins}

                            >
                            </ReactBingmaps>
                        </div>
                        <div className='track-map-list'>
                            {stepDescription ? <Timeline>
                                {stepDescription.map(des => (
                                    <Timeline.Item id={"step"+des.id} key={"step"+des.id}><p style={this.state.activeId === ("step"+des.id)?{color:"#2975d5",paddingTop:3}:(des.sts !== 'N'?{color:"rgba(0, 0, 0, 0.9)",paddingTop:3}:{color:"rgba(0,0,0,.45)",paddingTop:3})}>{this.steDescription(des)}</p></Timeline.Item>
                                ))}
                            </Timeline> : null}
                        </div>
                    </div>
                </div>
                <Modal
                    title="请选择订单号"
                    visible={visible}
                    onCancel={this.hideModal}
                    footer={[<Button onClick={this.onOrderOk} type='primary'>确定</Button>]}
                >
                    <Select style={{width:'300px'}} defaultValue={recordNo} onChange={this.handleSelectChange}>
                        {recordNoData.map(c => (
                            <Option value={c} key={c}>{c}</Option>
                        ))}
                    </Select>
                </Modal>
            </div>
        )
    }
}
export default TrackQuery

